import { lazy } from 'react';
import { PermissionsGuard } from './components';
import { VEHICLES_AUTH, CREATE_PERMISSION, READ_PERMISSION, UPDATE_PERMISSION } from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/vehicles',
        guard: PermissionsGuard,
        roles: {
            permission: VEHICLES_AUTH,
            crud: CREATE_PERMISSION
        },
        component: lazy(() => import('src/views/vehicle/VehicleCreateView')),
    },
    {
        exact: true,
        path: '/management/vehicles/:id',
        guard: PermissionsGuard,
        roles: {
            permission: VEHICLES_AUTH,
            crud: READ_PERMISSION
        },
        component: lazy(() => import('src/views/vehicle/VehicleDetailsView')),
    },
    {
        exact: true,
        path: '/management/vehicles/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: VEHICLES_AUTH,
            crud: UPDATE_PERMISSION
        },
        component: lazy(() => import('src/views/vehicle/VehicleEditView')),
    },
    {
        exact: true,
        path: '/management/vehicles',
        guard: PermissionsGuard,
        roles: {
            permission: VEHICLES_AUTH,
            crud: READ_PERMISSION
        },
        component: lazy(() => import('src/views/vehicle/VehicleListView')),
    },
];
